// extracted by mini-css-extract-plugin
export default {"agree-to-terms":"agree-to-terms-cefa","second-line":"second-line-33d5","agree-to-terms-bold":"agree-to-terms-bold-7014"};